import React from 'react';
import { useParams } from 'react-router-dom';
import { useQuery } from '@apollo/client';
import EditTxn from './edit';
import { TXN } from './queries';
import DataState from 'app/src/components/DataState';
import { Text } from 'react-native';
import {
  ContentContainer
} from 'app/src/elements';

const Txn = () => {
  const { id } = useParams();

  const { data, refetch } = useQuery(TXN, { variables: { id } });

  if (!data) { return <DataState.Loading />; }

  return (
    <ContentContainer>
      <Text style={{fontSize: '20px', fontWeight: 'bold', marginBottom: '20px'}}>
        {`Edit ${data?.txn.name} Transaction`}
      </Text>
      <EditTxn txn={data.txn} refetch={refetch} />
    </ContentContainer>
  )
}

export default Txn;
